/**
 * Coup de pouce — Attendu 1098 « comparaison de fractions » (automatisme 4e,
 * l. 653). QUATRE pages STATIQUES, une par cas, partagées par les trois
 * generator_keys : trois pages de la fiche 1052 (importées, mêmes bandes,
 * mêmes sacrifiés) et UNE page neuve pour le cas de 4e. La page « Même
 * dénominateur » de 1052 saute (plafond de quatre pages) : sa règle est la
 * dernière ligne de la page neuve.
 *
 * La page neuve, « Le même dénominateur d'abord » : les deux bandes de 1052,
 * 3/4 en quarts au-dessus, 5/8 en huitièmes dessous ; on VOIT que chaque
 * quart vaut deux huitièmes. Deux lignes en langue d'élève : « 3/4, c'est
 * 6/8 : même dénominateur que 5/8. » et « 6 parts contre 5 parts : 3/4
 * est plus grand. » Le geste de 1097 (un nombre des deux tables), au service
 * de la comparaison.
 *
 * SACRIFIÉS : les quatre couples de 1052 (importés) et 3/4 avec 5/8
 * (gen_1098, COUPLE_SACRIFIE, auto-testé par gen1098.self.test.js).
 */
import { figure, SVG_MEME_NUM, SVG_MOITIE, SVG_UN } from './1052';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const gras = (texte, couleur) => `<tspan font-weight="bold" fill="${couleur}">${texte}</tspan>`;

const SVG_COMMUN = figure({
    haut: { a: 3, b: 4 }, bas: { a: 5, b: 8 }, fin: 1, repere: null, sym: '&gt;',
    regles: [
        `${gras('3 sur 4', ORANGE)}, c'est 6 sur 8 : même dénominateur que ${gras('5 sur 8', BLEU)}.`,
        `${gras('6 parts', ORANGE)} contre ${gras('5 parts', BLEU)} : 3 sur 4 est plus grand.`,
    ],
    aria: 'Deux bandes de même longueur, de 0 à 1, l\'une sous l\'autre. Bande du haut partagée en 4 parts, 3 coloriées : 3 sur 4. Bande du bas partagée en 8 parts, 5 coloriées : 5 sur 8. 3 sur 4 est plus grand que 5 sur 8. 3 sur 4, c\'est 6 sur 8 : le même dénominateur que 5 sur 8. 6 parts contre 5 parts : 3 sur 4 est plus grand.',
});

const AIDE = {
    pages: [
        { titre: 'Même numérateur', svg: SVG_MEME_NUM },
        { titre: 'Repère 1/2', svg: SVG_MOITIE },
        { titre: 'Repère 1', svg: SVG_UN },
        { titre: 'Le même dénominateur d\'abord', svg: SVG_COMMUN },
    ],
};

const CP_1098 = {
    flash_texte_trou_saisie: AIDE,
    ecriture_qcm_unique: AIDE,
    plus_tableau_vf: AIDE,
};

export default CP_1098;
